<!-- Search bar  -->
<div #search_dropdown class="web__searchbar fnt-14" [class.focused]="search_down">
      <!-- (mouseup)="searchproduct($event)" (ngModelChange)="searchproduct($event)"  -->
      
    <div class="d__flex">
      <ion-input (ionFocus)="search_down = true" (click)="show_category = true" (ionBlur)="search_down = false" autocomplete="off" (ionChange)="searchproduct($event)"  name="search" [(ngModel)]="keyword" placeholder="Search products..."></ion-input>
      <!-- routerLink="/search" [queryParams]="{ q: keyword }"  routerDirection="forward"  routerLink="/search" [queryParams]="{ q: keyword }"  -->
      <ion-button fill="clear" class="search-btn" (click)="icon_searchproduct($event)">
        <!-- <img class=" icon mouse" *ngIf="db.website_settings && db.website_settings.app_settings && db.website_settings.app_settings.header_search_icon" [src]="db.product_img(db.website_settings.app_settings.header_search_icon)"> -->
         <ion-icon name="search"></ion-icon>
      </ion-button>
    </div>
  
<!-- [class.focused]="search_down" -->
    <div *ngIf="db.search_productss.length != 0  && search_value" id="search__down" class="search__dropdown" (mouseleave)="search_value = false">

      <div class="search__product d__flex gap-10 mouse" *ngFor="let item of db.search_productss;let i = index" [id]="i+'s'" [class.active_dropdown]="i == active_dropdwon"  (click)="selected_products(item)">
          <ion-avatar><img [src]="db.product_img(item.image )"> </ion-avatar>
          <ion-label class="fnt-14 webkit-text " [style.--line]="2" >{{item.item| titlecase}}</ion-label>
          <ion-label class="fnt-14 webkit-text " [style.--line]="1" [innerHtml]="item.attribute_html"></ion-label>
          <ion-icon name="chevron-forward-outline"></ion-icon>
      </div>

    </div>

<!-- empty_search_productss.length != 0 && search_value -->
    
<!-- <div *ngIf="db.viewcontent_serach.length != 0 && (!keyword || keyword == '') && show_category" id="search__down" class="empty_search__dropdown d__flex"  (mouseleave)="search_value = false">
      
      <h6 class="m-0 search_e">Enter a text to search a products...</h6>

      <h6 class="m-0 top_e">Top categories</h6>
      <div class="grid_item_search" *ngFor="let item of db.viewcontent_serach;let i = index" [id]="i+'s'"  (click)="show_category = false"  (click)="db.childs.child_1_name = undefined" [routerLink]="!db.ismobile?'/c/'+item.route:'/c/'+item.route">
        <div class="image">
          <img [src]="db.product_img(item.mobile_image || item.image)"> 
        </div>
        <div class="title">
           <ion-label>{{item.category_name  || item.item_title  | titlecase}}</ion-label>
        </div> 
      </div>
    </div> -->

</div>